import { ClosedLostGroupBy, ClosedLostSubmissionStage } from './types';

export { DATE_RANGE_OPTIONS } from '../pipelineAndWon/constants';

export const GROUP_BY_OPTIONS: { value: ClosedLostGroupBy; label: string }[] = [
  { value: 'SALES_REP', label: 'Sales Rep' },
  { value: 'LOCATION', label: 'Location' },
  { value: 'FINANCE_MGR', label: 'Finance Mgr' },
  { value: 'SALES_MGR', label: 'Sales Mgr' },
];

export const SUBMISSION_STAGE_OPTIONS: { value: ClosedLostSubmissionStage; label: string }[] = [
  { value: 'ALL', label: 'All' },
  { value: 'SUBMITTED_ONLY', label: 'Submitted only' },
];
